import ProductCategoryForm from "../../ProductCategories/component/ProductCategoryForm/ProductCategoryForm";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import NewsCategories from "../NewsCategories";
import NewsCategoryForm from "../component/NewsCategoryForm/NewsCategoryForm";
import {getManagerHeader, getReporterHeader} from "../../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../../assets/Constants";
import {base64DecodeUnicode, toastSuccess} from "../../../assets/functions";
import Loading from "../../../component/Loading/Loading";

const AddNewsCategories = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const category = {
        persianName: "",
        englishName: "",
        logos: [],
        avatars: [],
        activeLogo: "",
        activeAvatar: "",
        summary: "",
    }
    const [newsCategory , setNewsCategory ] = useState({
        category : {...category}
    })

    useEffect(() => {
        (async () => {
            document.title = "افزودن دسته بندی خبر"
            setIsLoading(false);
        })();

    }, []);


    const handleSubmit = async () => {
        setIsLoading(true);
        const headers = getReporterHeader();

        axios.post(baseCmsApiUrl + 'newsCategories', newsCategory, {headers})
            .then((response) => {
                console.log(response)
                console.log(response.data)
                toastSuccess(base64DecodeUnicode(response.statusText));
                // navigate("/newsCategories");
                return;
            })
            .catch((e) => {
                console.error(e)
                console.log(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
            setIsLoading(false)
        })
    }

    if (isLoading)
        return <Loading/>

    return (<div className="container-fluid p-0">
        <div className="mb-4">
            <h1 className="h3 d-inline align-middle">افزودن دسته بندی خبر</h1>
        </div>

        <NewsCategoryForm newsCategory={newsCategory} onChange={(value) => {
            setNewsCategory(value);
        }}/>

        <button className={"btn btn-secondary btn-lg w-100"} onClick={handleSubmit} disabled={isLoading}>افزودن
            دسته بندی
        </button>
    </div>)
}

export default AddNewsCategories;